<template>
  <svg class="icon icon--arrow" width="23px" height="41px" viewBox="0 0 23 41" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-43.000000, -492.000000)">
      <polygon fill="#FFFFFF" fill-rule="nonzero" points="44.0752276 511.681877 43 512.752078 44.0752276 513.822279 63.3430205 533 64.724332 531.372183 45.2020849 512.236129 45.2020849 513.822279 65.2103456 493.581684 63.8495447 492"></polygon>
    </g>
  </svg>
</template>

<script>
  export default{
    data(){
      return{}
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/icons/Arrow.vue